import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { SalesEnquiryStatus } from "@enums/salesEnquiryStatus.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { SalesEnquiry } from "@interfaces/models/salesEnquiry.interface";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { SalesEnquiryService } from "@services/salesEnquiry.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "salesEnquiries",
	styleUrls: ["salesEnquiries.css"],
	templateUrl: "salesEnquiries.html"
})
export class SalesEnquiriesAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	itemType = "Sales Enquiry"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: SalesEnquiry[] = [];
	statuses: any;
	title: string;
	users: any[] = [];

	constructor(private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: SalesEnquiryService, private protectedGridService: ProtectedGridService, private userProfileService: UserProfileService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.statuses = GetPropertiesFromEnum(SalesEnquiryStatus);
		this.title = "Sales Enquiries";
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.getUsers();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}

	boolYesNo(cellInfo: any) {
		if (cellInfo.value === true) {
			return "YES";
		}
		else {
			return "NO";
		}
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Sales Enquiries")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if (result) {
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}_edit`]);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getEnquiries()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getUsers() {
		this.userProfileService.getAllWithUsers()
			.subscribe(
				(res: any) => this.users = res.response,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	goToItems() {
		this.router.navigate(["admin/items"]);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Sales Enquiries";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	signedOffYesNo(cellInfo: any) {
		if (cellInfo.value === undefined || cellInfo.value === null || cellInfo.value <= 0) {
			return "NO";
		}
		else {
			return "YES";
		}
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}`]);
	}
}